/* Sliders y sonido de videos de las secciones aeris-*. Se vuelve a iniciar cuando el editor recarga una seccion. */
(() => {
  function initUgc(root) {
    root.querySelectorAll('[data-aeris-ugc]').forEach((ugc) => {
      if (ugc.dataset.ready) return;
      ugc.dataset.ready = '1';
      const vids = [...ugc.querySelectorAll('video')];
      vids.forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); });
      ugc.querySelectorAll('.snd').forEach((b) => b.addEventListener('click', () => {
        const v = b.parentElement.querySelector('video');
        const turnOn = v.muted;
        vids.forEach((x) => { x.muted = true; });
        ugc.querySelectorAll('.snd').forEach((x) => { x.setAttribute('aria-pressed', 'false'); x.setAttribute('aria-label', 'Activar sonido'); });
        if (turnOn) { v.muted = false; v.currentTime = 0; v.play(); b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-label', 'Silenciar'); }
      }));
    });
    root.querySelectorAll('.hero-dark video').forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-aeris-slider]').forEach((sl) => {
      if (sl.dataset.ready) return;
      sl.dataset.ready = '1';
      const track = sl.querySelector('.track'), prev = sl.querySelector('.prev'), next = sl.querySelector('.next'), bar = sl.querySelector('.progress span');
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width : 300) + 16;
      prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      next.addEventListener('click', () => track.scrollBy({ left: step() }));
      const upd = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        const w = track.clientWidth / track.scrollWidth * 100;
        bar.style.width = w + '%';
        bar.style.marginLeft = (max > 0 ? track.scrollLeft / max * (100 - w) : 0) + '%';
      };
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  const init = (root) => { initUgc(root); initSliders(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
